/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_content_delivery_bucket": "threepp-hosting-bucket-us-west-2-336892131278-devthree",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "https://d39f2mufs24fz4.cloudfront.net",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_Wq3bh7LHA",
    "aws_user_pools_web_client_id": "gd4ervlvblptsubitkln0aqaq",
    "oauth": {
        domain: 'engage-sso-devthree.auth.us-west-2.amazoncognito.com',
        scope: ['email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
        redirectSignIn: 'http://localhost:3000/',
        redirectSignOut: 'http://localhost:3000/logout/',
        responseType: 'code',
      },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://2iu3aahgerawdjc5qozyuihmei.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "threepp-initial-upload-us-west-2-336892131278-devthree",
    "aws_user_files_s3_bucket_region": "us-west-2",
    "aws_dynamodb_all_tables_region": "us-west-2",
    "aws_dynamodb_table_schemas": [
        {},
        {},
        {},
        {}
    ],
    "Analytics": {
        "disabled": true
    }
};


export default awsmobile;
